import { render, staticRenderFns } from "./InsertCarData.vue?vue&type=template&id=e608584a&scoped=true"
import script from "./InsertCarData.vue?vue&type=script&lang=js"
export * from "./InsertCarData.vue?vue&type=script&lang=js"
import style0 from "./InsertCarData.vue?vue&type=style&index=0&id=e608584a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e608584a",
  null
  
)

export default component.exports